import { render } from "./CaseDetail.vue?vue&type=template&id=4a51c6e6&scoped=true"
import script from "./CaseDetail.vue?vue&type=script&lang=js"
export * from "./CaseDetail.vue?vue&type=script&lang=js"

import "./CaseDetail.vue?vue&type=style&index=0&id=4a51c6e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a51c6e6"]])

export default __exports__